import { createSelector } from 'reselect';
import { get, isUndefined } from 'lodash';
import { RootStoreState } from '../reducers';

export const selectAuth = (state: RootStoreState) => get(state, 'auth');

export const selectTokens = createSelector(selectAuth, (auth) =>
  get(auth, 'tokens')
);

export const selectAccessToken = createSelector(selectTokens, (tokens) =>
  get(tokens, 'accessToken')
);

export const selectRefreshToken = createSelector(selectTokens, (tokens) =>
  get(tokens, 'refreshToken', null)
);

export const isUserLoggedIn = createSelector(
  selectAccessToken,
  (accessToken) => !isUndefined(accessToken)
);

export const selectUser = createSelector(selectAuth, (auth) => auth.user);

export const selectUserId = createSelector(selectAuth, (auth) => auth?.user?.id ?? null);

export const selectRoles = createSelector(selectAuth, (auth) => auth?.user?.permission ?? [])

const hasRole = (role: string) =>
  createSelector(selectRoles, (roles) => roles?.includes(role));

export const selectAuthorizedMPIChecklists = createSelector(
  hasRole('MPI_Checklists'),
  (authorized) => authorized
);
